import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Dictionary } from 'lodash';

import { WidgetSettings, WidgetSize, WorkspaceSettings } from './userSettings';

export interface LayoutStoreState {
  manageWorkspace?: WorkspaceSettings;
}

export const initialState: LayoutStoreState = {};

export const layoutSlice = createSlice({
  name: '~/scenes/MyWorkspace/layout',
  initialState,
  reducers: {
    enterManageWorkspace: (
      state: LayoutStoreState,
      action: PayloadAction<WorkspaceSettings>,
    ) => {
      state.manageWorkspace = action.payload;
    },
    leaveManageWorkspace: (
      state: LayoutStoreState,
      _: PayloadAction<undefined>,
    ) => {
      state.manageWorkspace = undefined;
    },
    addWidget: (
      state: LayoutStoreState,
      action: PayloadAction<WidgetSettings>,
    ) => {
      if (state.manageWorkspace) {
        state.manageWorkspace.widgets.push(action.payload);
      }
    },
    updateWidget: (
      state: LayoutStoreState,
      action: PayloadAction<WidgetSettings>,
    ) => {
      if (state.manageWorkspace) {
        const widgetIndex = state.manageWorkspace.widgets.findIndex(
          ({ id }) => id === action.payload.id,
        );

        if (widgetIndex > -1) {
          state.manageWorkspace.widgets[widgetIndex] = action.payload;
        }
      }
    },
    deleteWidget: (state: LayoutStoreState, action: PayloadAction<string>) => {
      if (state.manageWorkspace) {
        state.manageWorkspace.widgets = state.manageWorkspace.widgets.filter(
          ({ id }) => id !== action.payload,
        );
      }
    },
    updateWidgetsOrder: (
      state: LayoutStoreState,
      action: PayloadAction<string[]>,
    ) => {
      if (state.manageWorkspace) {
        state.manageWorkspace.widgets = state.manageWorkspace.widgets.sort(
          (a, b) => action.payload.indexOf(a.id) - action.payload.indexOf(b.id),
        );
      }
    },
    updateWidgetsSize: (
      state: LayoutStoreState,
      action: PayloadAction<Dictionary<WidgetSize>>,
    ) => {
      if (state.manageWorkspace) {
        state.manageWorkspace.widgets = state.manageWorkspace.widgets.map(
          (settings) => ({ ...settings, size: action.payload[settings.id] }),
        );
      }
    },
  },
});

export const {
  enterManageWorkspace,
  leaveManageWorkspace,
  addWidget,
  updateWidget,
  deleteWidget,
  updateWidgetsOrder,
  updateWidgetsSize,
} = layoutSlice.actions;
export const layoutReducer = layoutSlice.reducer;
